import { useTempEdgeTranslator } from '../../Hooks/useTranslation';

const createTagButton = (VariantButton, { defaultType = 'button', forwardEvent = true } = {}) => {
  const TagButton = ({
    tag,
    fallback,
    type = defaultType,
    invalid = false,
    pristine = false,
    disabled = false,
    onClick,
    class: buttonClass,
    className,
    ...rest
  }) => {
    const { tempedgeTranslator } = useTempEdgeTranslator();
    const handleClick = forwardEvent ? onClick : () => onClick?.();
    const classes = [buttonClass, className].filter(Boolean).join(' ');

    return (
      <div>
        <VariantButton {...rest} type={type} className={classes} disabled={invalid || pristine || disabled} onClick={handleClick}>
          {tempedgeTranslator(tag, undefined, fallback)}
        </VariantButton>
      </div>
    );
  };

  return TagButton;
};

export default createTagButton;
